module.exports = "/fonts/vendor/typeface-roboto/files/roboto-latin-400italic.woff?fe65b8335ee19dd944289f9ed3178c78";